define('views/modules/setting/business/modals/payment-finish-process-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'debug',
    'utils',
    'toastr',
    // services
    'services/i18n',
    'services/api',
    'services/session',
    // views
    'views/parts/modal/modal',
    // templates
    'text!templates/modules/setting/business/modals/payment-finish-process-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, DEBUG, U, Toastr,
    // sessions
    i18n,
    API,
    Session,
    // views
    VModal,
    //templates
    TPaymentFinishProcessdModal
) {
    var VPaymentFinishProcessModal = VModal.extend({
        template: TPaymentFinishProcessdModal,

        modal: function() {
            return {
                closeButton: false,
                message: Mustache.render(this.template, Mustache.getContext()),
                size: 'small',
                buttons: {
                },
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);
        },

        render: function() {
            this.generateZones();

            this.renderModal();

            this.completePayment();
            return this;
        },

        show: function(model) {
            this.render();
        },

        updatePopupContent: function() {
            var html = Mustache.render(this.template, Mustache.getContext());
        },

        completePayment: function(token, payerID) {
            Backbone.ajax(
                _.extend({
                    url: API.url("payments/finishPayment/"),
                    method: "POST",
                    dataType: "json",
                    data: {
                        token: this.options.params.token,
                        PayerID: this.options.params.PayerID
                    },
                    context: this,
                }, {
                    success: function(response, textStatus, jqXHR) {
                        this.close();

                        Toastr.success(
                            i18n.t("payment:finishing_payment_process_success_message"),
                            i18n.t("payment:finishing_payment_process_success_title"), {
                                positionClass: "toast-top-center",
                                newestOnTop: false,
                                showMethod: "slideDown",
                                tapToDismiss: false,
                                closeButton: true
                            }
                        );

                        Backbone.history.redirect('supervisor');
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        this.close();

                        Toastr.error(
                            i18n.t("payment:finishing_payment_process_error_message"),
                            i18n.t("payment:finishing_payment_process_error_title"), {
                                positionClass: "toast-top-center",
                                newestOnTop: false,
                                showMethod: "slideDown",
                                tapToDismiss: false,
                                closeButton: true
                            }
                        );

                        Backbone.history.redirect('supervisor');
                    }
                })
            );
        }
    });

    return VPaymentFinishProcessModal;
});

